import React from 'react';
import { InvoiceDocument } from '../types/invoice';
import { formatAmount } from './documentReviewTypes';
interface DocumentPreviewProps {
  document: InvoiceDocument;
}
export function DocumentPreview({
  document
}: DocumentPreviewProps) {
  return <div className="bg-white" data-id="element-5096">
      {/* Invoice Header - FROM VENDOR */}
      <div className="p-8 border-b border-gray-200" data-id="element-5097">
        <div className="flex justify-between items-start" data-id="element-5098">
          {/* Vendor (Supplier) Details - Left Side */}
          <div data-id="element-5099">
            <div className="font-bold text-2xl mb-2" data-id="element-5100">{document.supplier}</div>
            <div className="text-xs text-gray-600" data-id="element-5101">
              <div data-id="element-5102">123 Supplier Street</div>
              <div data-id="element-5103">Sydney NSW 2000</div>
              <div data-id="element-5104">Australia</div>
              <div className="mt-2" data-id="element-5105">Phone: (02) 9999 8888</div>
              {document.supplierABN && <div data-id="element-5106">ABN: {document.supplierABN}</div>}
            </div>
          </div>

          {/* Invoice Title - Right Side */}
          <div className="text-right" data-id="element-5107">
            <div className="text-3xl font-bold text-gray-900 mb-2" data-id="element-5108">INVOICE</div>
            <div className="text-sm font-medium text-gray-700" data-id="element-5109">
              {document.invoiceNumber}
            </div>
          </div>
        </div>
      </div>

      {/* Invoice Details */}
      <div className="p-8" data-id="element-5110">
        {/* Bill To - Customer */}
        <div className="mb-6 bg-gray-50 p-4 rounded border border-gray-200" data-id="element-5111">
          <div className="text-xs font-bold text-gray-700 mb-2 uppercase" data-id="element-5112">
            Bill To
          </div>
          <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-5113">
            Abbott Australasia Pty Ltd
          </div>
          <div className="text-xs text-gray-600" data-id="element-5114">
            <div data-id="element-5115">Level 4, 32-34 Lord Street</div>
            <div data-id="element-5116">Botany NSW 2019</div>
            <div data-id="element-5117">Australia</div>
            <div className="mt-2" data-id="element-5118">Phone: (02) 9384 3000</div>
            <div data-id="element-5119">ABN: 95 000 180 389</div>
          </div>
        </div>

        {/* Invoice Info */}
        <div className="grid grid-cols-4 gap-4 mb-6 text-xs" data-id="element-5120">
          <div data-id="element-5121">
            <div className="text-gray-600 mb-1 font-semibold" data-id="element-5122">Invoice Date</div>
            <div className="font-medium" data-id="element-5123">{document.invoiceDate}</div>
          </div>
          <div data-id="element-5124">
            <div className="text-gray-600 mb-1 font-semibold" data-id="element-5125">Due Date</div>
            <div className="font-medium" data-id="element-5126">{document.dueDate}</div>
          </div>
          <div data-id="element-5127">
            <div className="text-gray-600 mb-1 font-semibold" data-id="element-5128">Terms</div>
            <div className="font-medium" data-id="element-5129">Net 30 Days</div>
          </div>
          {document.poNumber && <div data-id="element-5130">
              <div className="text-gray-600 mb-1 font-semibold" data-id="element-5131">PO Number</div>
              <div className="font-medium text-blue-600" data-id="element-5132">
                {document.poNumber}
              </div>
            </div>}
        </div>

        {/* Line Items */}
        <table className="w-full mb-6 text-xs" data-id="element-5133">
          <thead className="bg-gray-100 border-b-2 border-gray-300" data-id="element-5134">
            <tr data-id="element-5135">
              <th className="text-left py-2 px-2 font-semibold" data-id="element-5136">Item Code</th>
              <th className="text-left py-2 px-2 font-semibold" data-id="element-5137">Description</th>
              <th className="text-right py-2 px-2 font-semibold" data-id="element-5138">Qty</th>
              <th className="text-right py-2 px-2 font-semibold" data-id="element-5139">Unit Price</th>
              <th className="text-right py-2 px-2 font-semibold" data-id="element-5140">Total</th>
            </tr>
          </thead>
          <tbody data-id="element-5141">
            {document.lineItems.map((item, index) => <tr key={index} className="border-b border-gray-200" data-id="element-5142">
                <td className="py-3 px-2 font-mono text-xs" data-id="element-5143">{item.itemCode}</td>
                <td className="py-3 px-2" data-id="element-5144">{item.description}</td>
                <td className="text-right py-3 px-2" data-id="element-5145">{item.quantity}</td>
                <td className="text-right py-3 px-2" data-id="element-5146">
                  {formatAmount(item.unitPrice, document.currency)}
                </td>
                <td className="text-right py-3 px-2 font-medium" data-id="element-5147">
                  {formatAmount(item.total, document.currency)}
                </td>
              </tr>)}
          </tbody>
        </table>

        {/* Totals */}
        <div className="flex justify-end" data-id="element-5148">
          <div className="w-64 text-xs" data-id="element-5149">
            <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-5150">
              <span data-id="element-5151">Subtotal:</span>
              <span className="font-medium" data-id="element-5152">
                {formatAmount(document.subtotal, document.currency)}
              </span>
            </div>
            <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-5153">
              <span data-id="element-5154">GST (10%):</span>
              <span className="font-medium" data-id="element-5155">
                {formatAmount(document.taxAmt, document.currency)}
              </span>
            </div>
            <div className="flex justify-between py-3 border-t-2 border-gray-900 font-bold text-base" data-id="element-5156">
              <span data-id="element-5157">Total {document.currency}:</span>
              <span data-id="element-5158">{formatAmount(document.total, document.currency)}</span>
            </div>
          </div>
        </div>

        {/* Payment Details */}
        <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-5159">
          <div className="text-xs" data-id="element-5160">
            <div className="font-semibold mb-2" data-id="element-5161">Payment Details:</div>
            <div className="text-gray-600" data-id="element-5162">
              <div data-id="element-5163">Bank: Commonwealth Bank</div>
              <div data-id="element-5164">BSB: 062 000</div>
              <div data-id="element-5165">Account: 1234 5678</div>
              <div className="mt-2" data-id="element-5166">
                Please include invoice number in payment reference
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 pt-4 border-t border-gray-200 text-center" data-id="element-5167">
          <div className="text-xs text-gray-500" data-id="element-5168">
            Thank you for your business!
          </div>
        </div>
      </div>
    </div>;
}